import { TVL_BREAKDOWN_COLORS } from '@/constants/charts'
import type { BreakdownItem } from '@/types/analytics'

const OTHER_COLOR = 'rgb(var(--body-foreground))'

export function getBreakdownItemColor(item: BreakdownItem, index: number): string {
  if (item.subItems?.length) return OTHER_COLOR
  return item.color ?? TVL_BREAKDOWN_COLORS[index % TVL_BREAKDOWN_COLORS.length] ?? 'transparent'
}
